<template>
  <div class="jr-mx-15 jr-text-left">
    <p class="jr-text-sm jr-font-medium">選択した駅利用者の居住地/勤務地をヒートマップで表示しています。</p>
    <p class="jr-text-s jr-pt-6.252">
      <span class="jr-mr-2.5">※</span>
      <span>パーソナルデータに配慮し位置を125M以内でランダマイズ処理しています。</span>
    </p>
  </div>
</template>
